import React from "react";
import {
  Box,
  Button,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import colors from "../../../assets/theme/colors";
import {
  CareSourceFileUploadButton,
  CARE_SOURCE_CONTEXTS,
} from "../../../features/careSourceProcessing";

const MedicationSourceCaptureCard = ({
  childId = "",
  onAddMedication,
  showHeader = true,
}) => {
  return (
    <Box
      sx={{
        p: showHeader ? 1.2 : 0,
        borderRadius: showHeader ? 2 : 0,
        border: showHeader ? "1px solid #BFDCDC" : "none",
        bgcolor: showHeader ? "#F8FCFC" : "transparent",
      }}
    >
      <Stack spacing={1}>
        {showHeader ? (
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontSize: "0.92rem", fontWeight: 850, color: colors.landing.heroText }}>
              Add medication
            </Typography>
            <Typography sx={{ mt: 0.2, fontSize: "0.78rem", color: colors.semantic.ink2, lineHeight: 1.35 }}>
              Add medications manually for the cleanest list, or upload a document for review.
            </Typography>
          </Box>
        ) : null}

        <Button
          variant="contained"
          onClick={() => onAddMedication?.()}
          sx={{
            width: "100%",
            minHeight: 48,
            borderRadius: 2.5,
            px: 1.6,
            fontSize: "0.94rem",
            fontWeight: 900,
            textTransform: "none",
            boxShadow: "none",
            bgcolor: colors.semantic.profileFlow.medicationManager.primaryAction,
            "&:hover": {
              bgcolor: colors.semantic.profileFlow.medicationManager.primaryActionHover,
              boxShadow: "none",
            },
          }}
        >
          Add medication manually
        </Button>

        <Divider sx={{ color: colors.semantic.ink2, "&::before, &::after": { borderColor: colors.semantic.profileFlow.medicationManager.controlBorder } }}>
          <Typography sx={{ fontSize: "0.78rem", fontWeight: 500, color: "#84928D" }}>
            or
          </Typography>
        </Divider>

        <CareSourceFileUploadButton
          childId={childId}
          sourceContext={CARE_SOURCE_CONTEXTS.MEDICATION}
          sourceType="medication_document"
          label="Upload medication document"
          showIcon={false}
          helperText="PDF, DOCX, TXT, CSV, or image"
          variantStyle="document"
          buttonSx={{
            bgcolor: '#FFFFFF',
            borderColor: colors.semantic.profileFlow.medicationManager.controlBorder,
            color: colors.semantic.profileFlow.medicationManager.actionText,
            boxShadow: 'none',
            '&:hover': {
              bgcolor: colors.semantic.profileFlow.medicationManager.controlHoverBg,
              borderColor: colors.semantic.profileFlow.medicationManager.controlBorderHover,
            },
          }}
          helperTextSx={{ color: colors.semantic.profileFlow.medicationManager.helperText }}
        />

      </Stack>
    </Box>
  );
};

export default MedicationSourceCaptureCard;
